import { contracts } from '../../data/contracts'

export default {
	name: 'BELLA',
	shortName: 'BELLA',
	contractAddress: contracts[process.env.REACT_APP_NETWORK].bellaAddres,
	url: 'http://lorem.com',
	logo: 'tokens/Bella.png'
}
